<template>
  <div class="page">
    <summary-header isHead />
    <summary-top>
      <v-chart
        :options="scoreRadar"
        autoresize
        ref="chart"
        style="height: 270px; width: 400px"></v-chart>
    </summary-top>
    <div class="summary-name">
      <summary-name
        :userNick="userNick"
        :userEmail="userEmail" />
      <p
        v-if="hasCompareAggregation"
        class="caption"
        style="margin: 0 !important">
        비교값 : [{{ compareName }}]
      </p>
    </div>
    <v-container class="contents">
      <v-row
        class="mt-8"
        dense>
        <v-col>
          <v-card
            tile
            elevation="0">
            <div class="d-flex mt-3">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">2nd Life 준비도</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="5">
                  <p class="question mb-0">
                    생애설계 4대 영역에 대한
                    <span class="subtitle-2">준비수준</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    <span class="secondary--text font-weight-black">{{ high }}</span>
                    영역이 &nbsp;
                    <span class="secondary--text font-weight-black">{{ highScore }}</span>
                    점으로 가장높음
                    <br />
                    <span class="orange--text text--darken-4 font-weight-black">{{ low }}</span>
                    영역이 &nbsp;
                    <span class="orange--text text--darken-4 font-weight-black">{{ lowScore }}</span>
                    점으로 가장낮음
                  </p>
                </v-col>
                <v-col>
                  <p class="question mb-0">
                    생애영역 key word중에서 준비도 점수가 낮아
                    <span class="subtitle-2">점검과 보완이 필요한 항목</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{
                      rankName
                        .slice(4)
                        .map((k) => `(${k.category})${k.text}`)
                        .join(', ')
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-row
                class=""
                style="margin-top: -20px">
                <v-col>
                  <v-card
                    tile
                    elevation="0">
                    <div class="d-flex mt-3">
                      <div class="section-title">
                        2nd Life 생애 주요영역
                        <span class="text-caption">부항목별점수(10점기준)</span>
                      </div>
                      <div class="section-title-border"></div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  <h3>
                    관계
                    <span class="text-caption">{{ getTotalScoreText(0) }}</span>
                  </h3>
                  <v-list
                    dense
                    class="pa-0">
                    <v-list-item
                      style="min-height: 24px; !important; border-bottom: 1px solid lightgrey;"
                      v-for="item in likertSheet.filter((k) => k.subCategory === '관계')"
                      :key="item.sumary">
                      <v-list-item-content class="pa-0">
                        <v-list-item-title>{{ item.summary }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action-text>{{ getScoreText(item) }}</v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="6">
                  <h3>
                    건강
                    <span class="text-caption">{{ getTotalScoreText(3) }}</span>
                  </h3>
                  <v-list
                    dense
                    class="pa-0">
                    <v-list-item
                      style="min-height: 24px; !important; border-bottom: 1px solid lightgrey;"
                      v-for="item in likertSheet.filter((k) => k.subCategory === '건강')"
                      :key="item.sumary">
                      <v-list-item-content class="pa-0">
                        <v-list-item-title>{{ item.summary }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action-text>{{ getScoreText(item) }}</v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row
                dense
                class="mt-3">
                <v-col cols="6">
                  <h3>
                    재무
                    <span class="text-caption">{{ getTotalScoreText(1) }}</span>
                  </h3>
                  <v-list
                    dense
                    class="pa-0">
                    <v-list-item
                      style="min-height: 24px; !important; border-bottom: 1px solid lightgrey;"
                      v-for="item in likertSheet.filter((k) => k.subCategory === '재무')"
                      :key="item.sumary">
                      <v-list-item-content class="pa-0">
                        <v-list-item-title>{{ item.summary }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action-text>{{ getScoreText(item) }}</v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="6">
                  <h3>
                    진로
                    <span class="text-caption">{{ getTotalScoreText(2) }}</span>
                  </h3>
                  <v-list
                    dense
                    class="pa-0">
                    <v-list-item
                      style="min-height: 24px; !important; border-bottom: 1px solid lightgrey;"
                      v-for="item in likertSheet.filter((k) => k.subCategory === '커리어')"
                      :key="item.sumary">
                      <v-list-item-content class="pa-0">
                        <v-list-item-title>{{ item.summary }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action-text>{{ getScoreText(item) }}</v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row></v-row>
    </v-container>
    <v-footer
      padless
      color="transparent">
      <v-col class="text-center pa-0">
        <span class="caption">&copy;삼성금융경력컨설팅센터</span>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations, mapState } from 'vuex'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/graphic'
import SummaryHeader from './SummaryHeader.vue'
import SummaryTop from './SummaryTop.vue'
import SummaryName from './SummaryName.vue'
import { mapStates } from 'vuex'
export default {
  components: { SummaryHeader, SummaryTop, SummaryName, 'v-chart': ECharts },
  name: 'LifeDesign',
  mounted() {
    this.$nextTick(() => {
      console.log('LIFE DESIGN MOUNTED')
      // const { aggregation, name, classId } = this.compareAggregtion
      if (this.hasCompareAggregation) {
        const { aggregation, name, id } = this.compareAggregation

        this.aggregation = aggregation
        this.compareName = name
        this.compareClassId = id

        const kk = aggregation.map(({ desc, ...rest }) => ({
          subCategory: desc.replace(/\[(.+)\]\s(.+)$/, '$1-$2').split('-')[0],
          summary: desc.replace(/\[(.+)\]\s(.+)$/, '$1-$2').split('-')[1],
          ...rest,
        }))
        // console.log(kk)
        this.drawChart(kk)
      } else this.drawChart()
    })
  },

  data() {
    return {
      aggregation: [],
      compareName: '',
      compareClassId: '',
      high: '',
      highScore: 0,
      low: '',
      lowScore: 0,
      orderColor: ['#5BBDE7', '#FC472B', '#5BBDE7', '#FC472B'],
      scoreSheet: [],
      likertSheet: [],
      rankName: [],
      scoreRadar: {
        // title: {
        //   text: '能力雷达图',
        // },
        tooltip: {},
        radar: {
          startAngle: 90,
          splitNumber: 3,
          shape: 'circle',
          name: {
            formatter: '{value}',
            textStyle: {
              color: '#757575',
              fontSize: 8,
              fontWeight: 'bold',
            },
          },
          splitArea: {
            areaStyle: {
              color: ['rgba(255, 255, 255, 0.2)', 'rgba(255, 255, 255, 0.4)', 'rgba(255, 255, 255, 0.6)'],
              // color: ['rgba(114, 172, 209, 0.2)', 'rgba(114, 172, 209, 0.4)', 'rgba(114, 172, 209, 0.6)', 'rgba(114, 172, 209, 0.8)', 'rgba(114, 172, 209, 1)'],
              // shadowColor: 'rgba(0, 0, 0, 0.3)',
              // shadowBlur: 10,
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(122, 122, 122, 0.5)',
            },
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(122, 122, 122, 0.5)',
            },
          },
          nameGap: 5,
          radius: ['0%', '80%'],
        },
        series: [
          {
            name: '',
            type: 'radar',
            data: [
              {
                value: [],
              },
            ],
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['master', 'userNick', 'userEmail', 'classId', 'hasCompareAggregation', 'compareAggregation']),
    orderScore() {
      //잘이루어놓은 것
      const g1 = this.master['Master-ordering-1'].list.map((o, i) => ({
        ...o,
        score: o.order,
      }))
      //위협적인것
      const t1 = this.master['Master-ordering-2'].list.map((o, i) => ({
        ...o,
        score: Math.abs(o.order - 7),
      }))

      // const g2 = _.keyBy(g1, 'title')
      const t2 = _.keyBy(t1, 'title')

      const sum = g1.map((k) => ({
        title: k.title,
        score: k.score + t2[k.title].score,
      }))
      // console.log(g1, t1, t2, sum)
      return _.orderBy(sum, ['score'], ['desc'])
        .slice(0, 3)
        .map((o) => o.title)
    },
    order() {
      // this.setExample()
      //잘이루어놓은 것
      const g1 = _.orderBy(this.master['Master-ordering-1'].list, ['order'], ['asc'])

      const k = [
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
      ]
      const g = {
        돈: 0,
        집: 1,
        일: 2,
        벗: 3,
        낙: 4,
        건강: 5,
      }

      //위협적인 것
      const t1 = _.orderBy(this.master['Master-ordering-2'].list, ['order'], ['asc'])
      // console.log(g1,t1)
      // console.log(g1[0].title, g1[5].title, t1[0].title, t1[1].title, t1[5].title, t1[4].title)
      k[g[g1[0].title]][0] = true
      k[g[g1[1].title]][0] = true
      k[g[g1[4].title]][1] = true
      k[g[g1[5].title]][1] = true
      k[g[t1[5].title]][2] = true
      k[g[t1[4].title]][2] = true
      k[g[t1[0].title]][3] = true
      k[g[t1[1].title]][3] = true
      return k
    },
  },
  methods: {
    getTotalScoreText(idx) {
      if (this.compareSheet[idx]) return `(${this.scoreSheet[idx]}점 - [${this.compareSheet[0].toFixed(1)}]점)`
      else return `(${this.scoreSheet[idx]}점)`
    },
    getScoreText(item) {
      if (item.avg) return `${item.value} - [${item.avg}]`
      else return `${item.value}`
    },
    getOrderStr(n) {
      if (n == 1) return 'st'
      if (n == 2) return 'nd'
      if (n == 3) return 'rd'
    },
    drawChart(compare = []) {
      const c = compare.reduce((a, c) => {
        a[c.subCategory + '-' + c.summary] = c
        return a
      }, {})
      const k = Object.keys(this.master).filter((k) => k.includes('likert'))
      const likertSheet = k.map((k) => this.master[k]).map((k) => ({ ...k, avg: c[k.subCategory + '-' + k.summary]?.avg }))
      const sum = likertSheet.reduce((a, c) => {
        if (!a[c.subCategory]) {
          a[c.subCategory] = c.value
        } else a[c.subCategory] += c.value
        return a
      }, {})

      const compareSum = likertSheet.reduce((a, c) => {
        if (!a[c.subCategory]) {
          a[c.subCategory] = c.avg || 0
        } else a[c.subCategory] += c.avg

        a[c.subCategory] = Math.round(a[c.subCategory])

        return a
      }, {})
      this.likertSheet = likertSheet
      this.scoreSheet = [sum['관계'], sum['재무'], sum['커리어'], sum['건강']]
      this.compareSheet = [compareSum['관계'], compareSum['재무'], compareSum['커리어'], compareSum['건강']]

      // console.log(likertSheet)

      const ss = Object.keys(sum).map((k) => ({ subCategory: k, value: sum[k] }))
      const so = _.orderBy(ss, ['value'], ['desc'])
      this.high = so[0].subCategory
      this.highScore = so[0].value
      this.low = so[3].subCategory
      this.lowScore = so[3].value
      // console.log(likertSheet)

      const rk = _.orderBy(likertSheet, ['value'], ['desc']).map((o) => ({
        category: o.subCategory,
        text: o.summary,
      }))
      // console.log(rk)

      const rr = [].concat(rk.slice(0, 4)).concat(rk.slice(0).reverse().slice(0, 4))

      this.rankName = rr

      const opt = this.scoreRadar
      opt.radar.indicator = [
        { name: `관계\n(${this.scoreSheet[0]} - [${this.compareSheet[0]}])`, max: 100 },
        { name: `재무\n(${this.scoreSheet[1]} - [${this.compareSheet[1]}])`, max: 100 },
        { name: `커리어\n(${this.scoreSheet[2]} - [${this.compareSheet[2]}])`, max: 100 },
        { name: `건강\n(${this.scoreSheet[3]} - [${this.compareSheet[3]}])`, max: 100 },
      ]
      opt.series[0].data[0] = {
        value: this.scoreSheet,
        lineStyle: {
          type: 'solid',
          width: 2,
          color: 'rgba(182, 51, 50,1)',
        },

        areaStyle: {
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          shadowBlur: 10,
          color: new ECharts.graphic.RadialGradient(0.5, 0.5, 1, [
            {
              color: '#E65100',
              offset: 0,
            },
            {
              color: '#FFCC80',
              offset: 1,
            },
          ]),
          // color: 'rgba(182, 51, 50, 0.5)',
          // color: 'rgba(251, 140, 0, 1, 1)',
        },
        label: {
          show: false,
          position: 'top',
          distance: 15,

          textStyle: {
            color: '#757575',
            fontSize: 18,
            fontWeight: 'bold',
          },

          formatter: function (params) {
            return params.name + ' ' + params.value
          },
        },
      }
      if (compare.length > 0)
        opt.series[0].data[1] = {
          value: this.compareSheet,
          lineStyle: {
            type: 'solid',
            width: 1,
            color: 'rgba(55, 51, 50,1)',
          },

          areaStyle: {
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 10,
            // color: new ECharts.graphic.RadialGradient(0.5, 0.5, 1, [
            //   {
            //     color: '#E65100',
            //     offset: 0,
            //   },
            //   {
            //     color: '#FFCC80',
            //     offset: 1,
            //   },
            // ]),
            color: 'rgba(182, 51, 50, 0.3)',
            // color: 'rgba(251, 140, 0, 1, 0.3)',
          },
          label: {
            show: false,
            position: 'top',
            distance: 15,

            textStyle: {
              color: '#757575',
              fontSize: 18,
              fontWeight: 'bold',
            },

            formatter: function (params) {
              return params.name + ' ' + params.value
            },
          },
        }

      if (this.$refs.chart) this.$refs.chart.mergeOptions(opt)
    },
  },
}
</script>

<style
  lang="scss"
  scoped>
.summary-name {
  position: absolute;
  left: 40px;
  top: 200px;
}
.page {
  position: relative;
  border: 1px solid white;
  // width: 2480px;
  // height: 3508px;
  width: 21cm;
  height: 29.7cm;
  margin: auto;
  page-break-before: always;

  // @media print {
  //   body {
  //     width: 21cm;
  //     height: 29.7cm;
  //     margin: 30mm 45mm 30mm 45mm;
  //     /* change the margins as you want them to be. */
  //   }
  // }
  .contents {
    // border-top: 1px solid black;
    margin-top: 113px + 119px + 120px;
    height: 1070px - 113px - 119px - 100px;
    padding: 0 40px;

    .section-title {
      padding-top: 0px;
      font-weight: 900;
      font-size: 18px;
      height: 18px;
      color: #1c5eaa;
      font-family: 'SamsungSans';
    }
    .section-title-border {
      height: 20px;
      margin-left: 10px;
      flex-grow: 1;
      border-bottom: 1px solid #165caa;
    }
    .ans {
      height: 60px;
      color: black;
    }
    .top-border {
      border-top: 3px solid grey;
    }
    .bottom-border {
      border-bottom: 3px solid grey !important;
    }
    .header-col {
      border-right: 1px solid grey;
      padding: 0px 12px;
      .cell {
        padding: 10px 0px;
        border-bottom: 1px solid grey;
        line-height: 40px;
      }
    }
    .row.cell {
      margin: 0px 0px;
      font-size: 12px;
    }
    .content-cell {
      padding: 10px 0px;
      height: 62px;
      border-bottom: 1px solid grey;
    }
    .icon-shadow {
      // text-shadow: 0px 0px 10px rgb(0 0 0 / 43%);
    }
    span.keyword {
      font-size: 16px;
      margin-right: 8px;
    }
    .cell2 {
      width: 100%;
    }
    .left-border {
      border-left: 2px solid grey;
    }
    .life-top {
      font-size: 1em;
    }
    .life-title > span {
      line-height: 50px;
      vertical-align: bottom;
    }
    .header-top {
      border-bottom: 3px solid grey !important;
    }
    .life {
      text-align: center;
      min-height: 64px;
    }
    .life-footer {
      margin-top: 20px;
    }
  }
  .footer {
    border-bottom: 1px solid grey;
    display: flex;
    align-items: flex-end;
    span {
      display: inline-block;
    }
  }
}
</style>
